import { SecretValue } from "../Apps/common";
import { environmentHttpClient } from "../httpClient";

export type SibiConnectionViewModel = {
	subdomain: string;
	initializationVector: string;
};

export function getConfiguration(signal?: AbortSignal): Promise<OptionalModel<SibiConnectionViewModel>> {
	return environmentHttpClient.get<OptionalModel<SibiConnectionViewModel>>(
		"/UiApi/SibiConfiguration",
		undefined,
		{ signal }
	);
}

export type SibiConnectionSaveModel = {
	subdomain: string;
	initializationVector: string;
	encryptionKey: SecretValue;
};

export function setConfiguration(
	model: SibiConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/SibiConfiguration",
		model,
		{ signal }
	);
}

export function deleteConfiguration(signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.delete<void>(
		"/UiApi/SibiConfiguration",
		undefined,
		{ signal }
	);
}
